import { instance } from "../axios/axiosConfig";
import { croInstance } from "../axios/axiosCroConfig";
import {
  GrowthMarketingPayload,
  OnboardingStatusResponse,
  GenerateLandingPagePayload,
} from "../types/onboardingTypes";

const onboardingApi = {
  fetchStubCampaign(brandId: number) {
    return instance.get(`/api/brand-view/${brandId}/stub-campaign/`);
  },
  postGrowthMarketingSetup(payload: GrowthMarketingPayload) {
    return instance.post(`/api/growth-marketing-setup/`, payload);
  },
  fetchOnboardingStatus(taskId: string) {
    return instance.get<OnboardingStatusResponse>(
      `/api/fast-onboarding/status/`,
      { params: { celery_task_id: taskId } },
    );
  },
  generateLandingPage(payload: GenerateLandingPagePayload) {
    return croInstance.post(`/funnels/from-brief`, payload);
  },
};

export default onboardingApi;
